import { render, staticRenderFns } from "./KurccInfiniteLoading.vue?vue&type=template&id=3bb96ca4&"
import script from "./KurccInfiniteLoading.vue?vue&type=script&lang=js&"
export * from "./KurccInfiniteLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports